import Collection_Base from 'collection/base';
import Model_Feedback_Comment_Template from 'model/feedback_comment_template';
import Constant from 'root/constants';
import Cache from 'root/cache';

export default Collection_Base.extend({
    model: Model_Feedback_Comment_Template,
    loaded: false,
    comparator: function(a, b) {
        // access_level FEEDBACK_COMMENT_TEMPLATE_ACCESS_TYPE_MYSELF and created_by current user is always on top
        // then sort by created_at
        const access_type_a = a.get('access_type').split(',').map(item => parseInt(item, 10));
        const access_type_b = b.get('access_type').split(',').map(item => parseInt(item, 10));

        const is_my_template_a = access_type_a.includes(Constant.FEEDBACK_COMMENT_TEMPLATE_ACCESS_TYPE_MYSELF);
        const is_my_template_b = access_type_b.includes(Constant.FEEDBACK_COMMENT_TEMPLATE_ACCESS_TYPE_MYSELF);

        if (is_my_template_a && !is_my_template_b) return -1;
        if (!is_my_template_a && is_my_template_b) return 1;

        // Compare by created_at
        const created_at_a = a.get('created_at');
        const created_at_b = b.get('created_at');

        if (created_at_a !== created_at_b) {
            return created_at_a > created_at_b ? -1 : 1;
        }

        // If created_at is the same, compare by id
        return a.id > b.id ? -1 : 1;
    },

    markAsLoaded: function() {
        this.loaded = true;
    },

    isLoaded: function() {
        return this.loaded;
    }
});